export default __webpack_public_path__ + "media/ErrorWindow.e92bfe05d39d56bda9c2326773de8589.svg";